



import React from 'react';

export default function imageOnError(event: React.SyntheticEvent<HTMLImageElement, Event>): void {
    const currentTarget = event.currentTarget;
    currentTarget.onerror = null; // prevents looping
    currentTarget.title='';
    currentTarget.width=16;
    currentTarget.height=16;
}
